import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function TargetAudience() {
  const forWho = ['Hombres y mujeres de 35 a 55 años que quieren optimizar su salud.', 'Personas que ya toman suplementos pero no están seguras de si lo hacen bien.', 'Quienes buscan opciones naturales y orgánicas y no saben cómo elegirlas.'];
  const notForWho = ['Personas que buscan "curas milagrosas" de un día para otro.', 'Quienes no están dispuestos a ser constantes con su rutina.'];
  return <Section bg="white" data-id="element-163">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-164">
        {/* For Who */}
        <div className="bg-sage-50 p-8 rounded-2xl border border-sage-200" data-id="element-165">
          <h3 className="text-2xl font-bold text-sage-900 mb-6 flex items-center gap-3" data-id="element-166">
            <CheckCircle2 className="text-sage-600 w-8 h-8" data-id="element-167" />
            Esta guía ES para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-168">
            {forWho.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-169">
                <CheckCircle2 className="w-6 h-6 text-sage-500 flex-shrink-0 mt-0.5" data-id="element-170" />
                <span className="text-charcoal-light text-lg" data-id="element-171">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For Who */}
        <div className="bg-cream-dark p-8 rounded-2xl border border-gray-200" data-id="element-172">
          <h3 className="text-2xl font-bold text-charcoal mb-6 flex items-center gap-3" data-id="element-173">
            <XCircle className="text-terracotta w-8 h-8" data-id="element-174" />
            Esta guía NO es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-175">
            {notForWho.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-176">
                <XCircle className="w-6 h-6 text-terracotta/70 flex-shrink-0 mt-0.5" data-id="element-177" />
                <span className="text-charcoal-light text-lg" data-id="element-178">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}